import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js"

// Connects to data-controller="organization-custom-url"
export default class extends Controller {
  static targets = ['previewOrgBtn', 'orgUrlContainer', 'orgEditUrlContainer', 'customUrlField',
    'domainErrorWrapper']

  connect() {
    this.debounceTimeout = null  // Store timeout for debouncing
  }
  
  editUrl() {
    this.customUrl = this.customUrlFieldTarget.value
    this.orgUrlContainerTarget.classList.add('d-none')
    this.previewOrgBtnTarget.classList.add('d-none')
    this.orgEditUrlContainerTarget.classList.remove('d-none')
  }

  cancelEditUrl() {
    this.customUrlFieldTarget.value = this.customUrl
    this.orgUrlContainerTarget.classList.remove('d-none')
    this.previewOrgBtnTarget.classList.remove('d-none')
    this.orgEditUrlContainerTarget.classList.add('d-none')
  }

  checkSubdomain() {
    clearTimeout(this.debounceTimeout)

    const subdomain = this.customUrlFieldTarget.value.trim()

    const subdomainRegex = /^[a-z0-9]+(-[a-z0-9]+)*$/
    if (!subdomainRegex.test(subdomain)) {
      this.showMsg("Subdomain must be lower case alphanumeric and can include single dashes between words.", 'red')
      return
    }

    if (subdomain === "") {
      this.showMsg("Subdomain cannot be empty.", 'red')
      return
    }

    // Debounce API request
    this.debounceTimeout = setTimeout(() => {
      this.clearError()
      this.verifySubdomain(subdomain)
    }, 500)
  }

  async verifySubdomain(subdomain) {
    try {
      const response = await get(`/organizations/check_subdomain`, {
        query: {subdomain},
        responseKind: "json"
      })

      if (response.ok) {
        const data = await response.json
        if (data.available) {
          this.clearError()
          this.showMsg("Subdomain is available!", 'green')  // Optional: display success message
        } else {
          this.showMsg("Subdomain is already taken.", 'red')
        }
      } else {
        this.showMsg("An error occurred while checking the subdomain. Please try again.", 'red')
      }
    } catch (error) {
      console.error("Error checking subdomain:", error)
      this.showMsg("An error occurred. Please try again.", 'red')
    }
  }

  showMsg(message, color) {
    this.domainErrorWrapperTarget.classList.remove('d-none')
    this.domainErrorWrapperTarget.innerHTML = `<span style="color: ${color};">${message}</span>`
  }

  clearError() {
    this.domainErrorWrapperTarget.classList.add('d-none')
    this.domainErrorWrapperTarget.innerHTML = ""
  }
}
